import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import { Database } from '@/_constants/database.types';

type PaperAttempt = Database['public']['Tables']['past_paper_attempts']['Row'];
type AttemptAnswer = Database['public']['Tables']['past_paper_attempt_answers']['Row'];

export interface PaperAttemptWithAnswers extends PaperAttempt {
  answers: AttemptAnswer[];
}

const usePaperAttempt = (attemptId: string | undefined) => {
  const queryFn = async (): Promise<PaperAttemptWithAnswers | null> => {
    if (!attemptId) return null;

    // Fetch attempt
    const { data: attempt, error: attemptError } = await supabaseClient
      .from('past_paper_attempts')
      .select('*')
      .eq('id', attemptId)
      .single();

    if (attemptError) throw attemptError;

    // Fetch answers for this attempt
    const { data: answers, error: answersError } = await supabaseClient
      .from('past_paper_attempt_answers')
      .select('*')
      .eq('attempt_id', attemptId)
      .order('created_at');

    if (answersError) throw answersError;

    return {
      ...attempt,
      answers: answers || [],
    };
  };

  return useQuery({
    queryKey: ['paper_attempt', attemptId],
    queryFn,
    enabled: !!attemptId,
  });
};

export default usePaperAttempt;
